import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { getPlantData, getClimateData } from "../../store/design/actions"
import ReactApexChart from "react-apexcharts"
import { getAreas, updateArea, deleteArea, addArea } from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import { useDrag, useDrop } from "react-dnd";
import GuildElement from "./guildelement"
import GuildFunction from "./guildfunction"

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { StorageImage } from '@aws-amplify/ui-react-storage';
import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardImgOverlay,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import { Image } from '@aws-amplify/ui-react';
import { Storage } from '@aws-amplify/storage'
import Spreadsheet from "react-spreadsheet"
import  BuildGuild  from "../Design/build-guild"
import CropPlanner from "../Design/crop-planner"

const Guilds = props => {
  const { plantMap, areaIndex, guildResults, summer, fall, spring, winter, profile,
    deletePlant, updateSpaceUsed, areas, setAreas, userareas, onSearchGuild, onUpdateArea } = props
  
  const [currPlant, setCurrPlant] = useState({})
  const [species, setSpecies] = useState()
  const [variety, setVariety] = useState()
  const [name, setName] = useState()
  const [space, setTotalSpace] = useState()
  const [searchguild, setSearchGuild] = useState(false)
  const [guildFunction, setGuildFunction] = useState()
  const [zone, setZone] = useState()
  const [climate, setClimate] = useState()
  const [layer, setLayer] = useState()
  const [buildGuildWizard, setBuildGuildWizard] = useState(false)

  function buildGuild() {
     setBuildGuildWizard(true)  
  }

   function deleteGuild(guildName) {
     var guildPlants = []
     for (var i=0; i<userareas[areaIndex].plants.length; i++) {
         var plant = userareas[areaIndex].plants[i]
         if (plant.guild==guildName)
             guildPlants.push(i)
     }

     var currArea = userareas[areaIndex]
     var newArea = { ...currArea }
     newArea.plants = currArea.plants.filter(plant => plant.guild!=guildName);
     delete newArea.guilds.guildName
     onUpdateArea(newArea)
  }

  async function printGuild(guildName) {
    const doc = new jsPDF("landscape"); // Landscape orientation
    const imgKey = `${username}-${userareas[areaIndex].name}-${guildName}`;

    try {
      // Fetch image URL using Amplify Storage
      const imgUrl = await fetchImageURL(imgKey);

      // Convert image to Base64
      const img = await getBase64Image(imgUrl);

      // Create a temporary image element to get intrinsic dimensions
      const tempImg = new window.Image();
      tempImg.src = img;
      await new Promise((resolve) => (tempImg.onload = resolve)); // Wait for the image to load

      const imgAspectRatio = tempImg.width / tempImg.height; // Original aspect ratio

      // Get PDF dimensions
      const pageWidth = doc.internal.pageSize.getWidth();
      const maxImgWidth = pageWidth * 0.75; // Set width to 75% of the page width
      const imgHeight = maxImgWidth / imgAspectRatio; // Scale height based on aspect ratio
      const xOffset = (pageWidth - maxImgWidth) / 2; // Center the image horizontally
      const yOffset = 10; // Top margin

      // Add image to PDF
      doc.addImage(img, "JPEG", xOffset, yOffset, maxImgWidth, imgHeight);

      // Prepare table data
      const guildData = userareas[areaIndex]?.guilds[guildName] || [];
      const tableBody = guildData.map((plant) => [
        plant.numPlants,
        plant.name,
        plant["latin name"] ? `<i>${plant["latin name"]}</i>` : "",
        plant.season,
        plant.size,
        plant.guildFunction.join(", "),
        plant.foodForestLayer,
      ]);

      // Add table
      autoTable(doc, {
        startY: yOffset + imgHeight + 10, // Position table below the image
        head: [
          [
            "Number of Plants",
            "Plant Name",
            "Scientific Name",
            "Plant Type",
            "Size",
            "Permaculture Functions",
            "Food Forest Layer",
          ],
        ],
        body: tableBody,
        headStyles: {
          fillColor: [0, 0, 0], // Black background for the header
          textColor: [255, 255, 255], // White text
        },
        styles: {
          fontSize: 10, // Smaller font size for table text
          overflow: "linebreak", // Wrap text within cells
        },
      });

      // Save PDF
      doc.save(`${guildName}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  }

  const fetchImageURL = async (imgKey) => {
      try {
        const url = await Storage.get(imgKey, {
          level: "guest", // Adjust access level based on your configuration
        });
        return url;
      } catch (error) {
        console.error("Error fetching image from Storage:", error);
        throw error;
      }
    };

    const getBase64Image = async (url) => {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };


  function finishWizard() {
    setBuildGuildWizard(false)
}


  const username = JSON.parse(localStorage.getItem("user")).user

  return (
 <Container fluid>
<Row>
    <Col md={12}>
    {!buildGuildWizard &&  <div>
	  <Row>
	   <Button     style={{margin:"0px", border: "0px"}}
                       onClick={e => { buildGuild()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Add New Guild
                   </Button>

     </Row>
     <Row>
    <h5>Existing Guilds</h5>
    </Row>
      {Object.keys(userareas[areaIndex].guilds).map((guildName, i) => (
        <div>
          <Row>
            <Col md={3}><b>{guildName}</b>
            <Button
                 onClick={e => {
                    deleteGuild(guildName)
                 }}
                 color="#FFFFFF"
                >
                     <i className="bx bx-trash" />
                </Button>
              <Button
                  onClick={e => {
                    printGuild(guildName)
                  }}
                  color="#FFFFFF"
              >
                <i className="bx bx-printer" />
              </Button>
           </Col>
           </Row>
           <Row>
          <StorageImage
               alt="fallback cat"
               style={{ width: '400px' }}
               imgKey={username+"-"+userareas[areaIndex].name + "-" + guildName}
               accessLevel="guest"
               onStorageGetError={(error) => console.error(error)}
            />
          </Row>
          <Row>
         <Col md={10}>
                   <Table className="table-nowrap table-centered mb-0">
                           <thead class="table-dark">
                              <tr>
                              <td>Number of Plants</td>
                              <td>Plant Name</td>
                              <td>Scientific Name</td>
                              <td>Plant Type</td>
                              <td>Size</td>
                              <td>Permaculture Functions</td>
                              <td>Food Forest Layer</td>
                              </tr>
                           </thead>
                           <tbody>

                           {userareas[areaIndex].guilds[guildName].map((plant, pindex) => (
                              <tr>
                              <td>{plant.numPlants}</td>
                              <td>{plant.name}</td>
                              <td><i>{plant['latin name']}</i></td>
                              <td>{plant.season}</td>
                              <td>{plant.size}</td>
                              <td>{plant.guildFunction.map(guild=> (
                                <span>{guild}<br/></span>

                                ))}</td>
                              <td>{plant.foodForestLayer}</td>
                           </tr>
                           ))}
                           </tbody>
                     </Table>
           </Col> 
         </Row>       
         </div>
      ))}
  
     </div>
   }

   {buildGuildWizard &&
    <BuildGuild currArea={userareas[areaIndex]} onUpdateArea={onUpdateArea} profile={profile} finishWizard={finishWizard}/>

   }
</Col>

</Row>




</Container>
   );
}
export default Guilds
